var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.28,
    height: 95.28,
    viewBox: "0 0 95.28 95.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video_play",
    "data-name": "Video play",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 47.64,
    cy: 47.64,
    r: 47.64,
    transform: "translate(-9 -9)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_636",
    "data-name": "Ellipse 636",
    cx: 36.897,
    cy: 36.897,
    r: 36.897,
    transform: "translate(1.743 1.743)",
    fill: "#fff",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_73",
    "data-name": "Polygon 73",
    d: "M11.724,0,23.449,20.69H0Z",
    transform: "translate(51.399 27.26) rotate(90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoplay);
export default __webpack_public_path__ + "static/media/Video play.d4aa98681a7eb828c74a546747b45fa4.svg";
export { ForwardRef as ReactComponent };